import type {
	AllowedActionable,
	Action,
} from 'pkg/api/models/allowed_actionable';

export function hasAllowedAction(
	item: AllowedActionable,
	action: Action
): boolean {
	return item?.allowedActions?.includes(action) ?? false;
}

export function hasAnyAllowedAction(item: AllowedActionable): boolean {
	return (item.allowedActions?.length ?? 0) > 0;
}
